import { filter, map } from "ramda";
import {
  NotifyType,
  posUserHasEmail,
  posUserHasPhone,
} from "helpers/schedule/scheduling_page";
import { IPosUser } from "types/schedules";
import {
  INotifyBody,
  INotifyEmailUserBody,
  INotifySmsUserBody,
} from "interfaces/schedule";

export function generateNotifyBody(
  notifyType: NotifyType,
  recipients: IPosUser[]
): INotifyBody {
  const recipientsWithEmail: INotifyEmailUserBody[] = map(
    (posUser: IPosUser) => {
      return { uuid: posUser.uuid, email: posUser.email.unsafelyUnwrap() };
    },
    filter(posUserHasEmail, recipients)
  );
  const recipientsWithPhone: INotifySmsUserBody[] = map((posUser: IPosUser) => {
    return { uuid: posUser.uuid, phone: posUser.phone.unsafelyUnwrap() };
  }, filter(posUserHasPhone, recipients));
  switch (notifyType) {
    case NotifyType.SMS_ONLY:
      return { email: [], sms: recipientsWithPhone };
    case NotifyType.EMAIL_ONLY:
      return { email: recipientsWithEmail, sms: [] };
    case NotifyType.SMS_AND_EMAIL:
      return { email: recipientsWithEmail, sms: recipientsWithPhone };
    default:
      return { sms: [], email: [] };
  }
}
